<h2 mat-dialog-title>Pull places for selected area</h2>

<mat-dialog-content>
  <div class="br-mb-2">
    <label class="br-form-label br-text-muted br-mb-1">Data source</label>
    <select class="br-form-select br-form-select--sm" [(ngModel)]="source">
      <option value="osm">OpenStreetMap (free)</option>
      <option value="google">Google Places (paid)</option>
    </select>
  </div>

  <div class="br-mb-2" *ngIf="source === 'google'">
    <label class="br-form-label br-text-muted br-mb-1">API key</label>
    <select class="br-form-select br-form-select--sm" [(ngModel)]="apiKeyId">
      <option [ngValue]="undefined" disabled>Select a key…</option>
      <option *ngFor="let k of apiKeys" [ngValue]="k.id">{{ k.name }}</option>
    </select>
    <div *ngIf="apiKeys.length === 0" class="br-text-muted br-small br-mt-1">
      No usable API keys — add one in Configuration first.
    </div>
  </div>

  <hr class="br-my-2" />

  <div class="br-flex br-justify-between"><span class="br-text-muted">Cells</span><span>{{ cellCount }}</span></div>
  <div class="br-flex br-justify-between"><span class="br-text-muted">Source</span><span>{{ source }}</span></div>
  <div class="br-flex br-justify-between"><span class="br-text-muted">Requests</span><span>{{ requestCount }}</span></div>
  <div class="br-flex br-justify-between">
    <span class="br-text-muted">Estimated budget</span>
    <span>{{ source === 'google' ? (budget | currency) : 'Free' }}</span>
  </div>

  <div class="br-text-muted br-small br-mt-2">
    Coverage is best-effort — completeness is limited by the data source, not BestRoute.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="br-btn br-btn--outline-secondary br-btn--sm br-me-2" (click)="cancel()">Cancel</button>
  <button class="br-btn br-btn--primary br-btn--sm" [disabled]="!canConfirm" (click)="confirm()">Start pull</button>
</mat-dialog-actions>
